import { render, staticRenderFns } from "./about_account.vue?vue&type=template&id=1aa896a0&scoped=true"
import script from "./about_account.vue?vue&type=script&lang=js"
export * from "./about_account.vue?vue&type=script&lang=js"
import style0 from "./about_account.vue?vue&type=style&index=0&id=1aa896a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa896a0",
  null
  
)

export default component.exports